<dialog
  #dialog
  qai-dialog
  [heading]="'simulationBuilder.EDIT_WEIGHTING_HEADING' | transloco"
  [description]="'simulationBuilder.EDIT_WEIGHTING_DESCRIPTION' | transloco"
  (afterClose)="handleClose()"
>
  <qai-item-grid
    [repeatCount]="'auto-fill'"
    [gap]="'40px'"
    [minItemWidth]="'140px'"
  >
    <qai-score-weightage
      *ngFor="let weight of localWeights; let i = index"
      [class.required-section]="isSelfAuthoring() && weight.section === 'Methodology'"
      [title]="weight.section"
      [enabled]="isSelfAuthoring() && weight.section === 'Methodology' ? true : !weight.disabled"
      [weight]="weight.value"
      [border]="false"
      [hasError]="fieldErrors['weight-' + i]"
      [enabledLabel]="isSelfAuthoring() && weight.section === 'Methodology' ? ('simulationBuilder.SCORING_WEIGHT_REQUIRED' | transloco) : ('simulationBuilder.ENABLED_TEXT' | transloco)"
      [disabledLabel]="isSelfAuthoring() && weight.section === 'Methodology' ? ('simulationBuilder.SCORING_WEIGHT_REQUIRED' | transloco) : ('simulationBuilder.DISABLED_TEXT' | transloco)"
      (checkboxEvent)="onDisableChange($event, i)"
      (inputFieldEvent)="onWeightInputChange($event, i)"
    ></qai-score-weightage>
  </qai-item-grid>
  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
  <div class="modal-actions">
    <button
      qai-button
      kind="secondary"
      [size]="'medium'"
      style="width: 100%"
      (click)="hideModal()"
    >
      {{ 'simulationBuilder.BUTTON_CANCEL' | transloco }}
    </button>
    <button
      qai-button
      kind="primary"
      [size]="'medium'"
      style="width: 100%"
      (click)="handleConfirm()"
      [disabled]="hasErrors()"
    >
      {{ 'simulationBuilder.BUTTON_CONFIRM' | transloco }}
    </button>
  </div>
</dialog>
